import Floater from './Floater';

export default Floater;



// WEBPACK FOOTER //
// ./src/components/shared/Floater/index.js